import { get, includes } from 'lodash';

import * as actions from 'state/actions';
import DataDogLogs from 'utils/DataDogLogs';
import Log from 'utils/Log';

const CONSENT_ALL_ACTIVE = ',C0001,C0002,C0003,C0004,';

let initPromise;

const OneTrustController = class {
  static get isOneTrustActive() {
    return !!get(window, ['ALLBIRDS', 'isOneTrustActive']);
  }

  /* Wait for callback to trigger in OptanonWrapper */
  static waitForOneTrust = () => {
    if (initPromise) return initPromise;
    initPromise = new Promise(resolve => {
      if (window.ALLBIRDS.consentInitialized) {
        resolve();
        return;
      }
      window.ALLBIRDS.onConsentInitialized = () => {
        resolve();
      };
    });
    return initPromise;
  };

  static async hasOneTrustLoaded() {
    return new Promise((resolve, reject) => {
      if (!OneTrustController.isOneTrustActive) {
        return resolve();
      }
      return initPromise.then(() => resolve()).catch(() => reject());
    });
  }

  static async hasPerformanceConsent() {
    return new Promise((resolve, reject) => {
      if (!OneTrustController.isOneTrustActive) {
        return resolve();
      }
      return initPromise
        .then(() => {
          if (includes(window?.OnetrustActiveGroups, 'C0002')) {
            return resolve();
          }
          return reject();
        })
        .catch(() => reject());
    });
  }

  static async hasFunctionalConsent() {
    return new Promise((resolve, reject) => {
      if (!OneTrustController.isOneTrustActive) {
        return resolve();
      }
      return initPromise
        .then(() => {
          if (includes(window?.OnetrustActiveGroups, 'C0003')) {
            return resolve();
          }
          return reject();
        })
        .catch(() => reject());
    });
  }

  static updateConsentFeatures = () => {
    OneTrustController.updateShopifyConsent(window?.OnetrustActiveGroups);
    DataDogLogs.init();
  };

  static updateShopifyConsent = consentGroups => {
    window.Shopify?.customerPrivacy?.setTrackingConsent?.(
      {
        analytics: includes(consentGroups, 'C0002'), // Performance consent
        marketing: includes(consentGroups, 'C0004'), // Targeting consent
        preferences: includes(consentGroups, 'C0003'), // Functional consent
      },
      () => {}
    );
  };

  static setConsentChangeListener() {
    if (!window.OneTrust?.OnConsentChanged) {
      Log.error(new Error('window.OneTrust.OnConsentChanged not found!'));
    }
    window.OneTrust?.OnConsentChanged?.(() => {
      OneTrustController.updateConsentFeatures();
    });
  }

  static initConsent = (store, activeGroups) => {
    store?.dispatch(actions.setInitialCookieConsentGroups(activeGroups));
    OneTrustController.updateShopifyConsent(activeGroups);
  };

  static init = store => {
    if (OneTrustController.isOneTrustActive) {
      OneTrustController.waitForOneTrust()
        .then(() => {
          OneTrustController.initConsent(store, window?.OnetrustActiveGroups);
          OneTrustController.setConsentChangeListener();
        })
        .catch(e => {
          OneTrustController.initConsent(store, CONSENT_ALL_ACTIVE);
          Log.error(e);
        });
    } else {
      store?.dispatch(actions.setInitialCookieConsentGroups(CONSENT_ALL_ACTIVE));
    }
  };
};

export default OneTrustController;
